import React, {PureComponent} from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"

import Tile from "../Tile"

interface Props extends InjectIntl {}

class CustomRewardTile extends PureComponent<Props> {
  render() {
    const {formatMessage} = this.props

    const reward = {
      header: formatMessage({id: "reward.customReward.card.title"}),
      thumbnailImage: formatMessage({id: "reward.customReward.card.image"}),
      cardImage: formatMessage({id: "reward.customReward.card.bannerImage"}),
      urlSlug: "custom-reward"
    }

    return (
      <Tile
        id="custom-reward-tile"
        reward={reward} />
    )
  }
}

export default injectIntl(CustomRewardTile)
